<template>
  <div
    class="percent-tag"
    :class="{
      'percent-tag--red': red || (red === undefined && real > planned),
      'percent-tag--grey': !planned
    }"
  >
    <template v-if="planned">{{ percent }}%</template>
    <template v-else>div0</template>
  </div>
</template>

<script>
export default {
  props: ['type', 'planned', 'real', 'red'],
  computed: {
    percent() {
      const r = this.real;
      const p = this.planned;

      if (!p) {
        return 0;
      }

      const output = Math.floor((r / p) * 100);

      return output > 999 ? '999+' : output;
    }
  }
};
</script>

<style scoped>
.percent-tag {
  align-items: center;
  background-color: #479538;
  border-radius: 3px;
  color: #fff;
  display: inline-flex;
  font-size: 11px;
  height: 15px;
  justify-content: center;
  margin-left: 5px;
  min-width: 40px;
  padding: 0 3px;
  -webkit-transition: background-color 0.6s;
  -moz-transition: background-color 0.6s;
  -ms-transition: background-color 0.6s;
  -o-transition: background-color 0.6s;
  transition: background-color 0.6s;
}

.percent-tag--red {
  background-color: #bf392a;
}
.percent-tag--grey {
  background-color: #cecece;
}
</style>